import React from 'react';

import NoFish from './assets/cantFindanyFishes.svg';
import { DisplayTemplate } from './display-results-template';

export const DisplayNoFishesTemplate = () => {
  return (
    <DisplayTemplate
      image={NoFish}
      title="Oh! There are no available fishes"
      subtitle={
        <>
          {' '}
          Let us not become weary in doing good, for at the proper time we will
          reap a harvest if we do not give up. <br />{' '}
          <strong>Galatians 6:9</strong>
        </>
      }
    />
  );
};
